import { articleFigure } from './articleFigure'
import { articleMetal } from './articleMetal'
import translations from './story09.content'
import type { Article } from './types'

const t = translations
// The directory holds fifteen frames; this piece uses 01–03 and the rest are spares.
const dir = '/mine-my-phone/images/articles/story09'
const figure = articleFigure(dir)

export const story09: Article = {
  id: 9,
  slug: 'how-tantalum-causes-wars-in-the-congo-drc',
  order: 9,
  title: t.title,
  excerpt: t.excerpt,
  image: `${dir}/01.jpg`,
  imageCaption: [...t.captions[0]],
  metal: articleMetal('tantalum'),
  // Hobbs took the testimony down; the words are Kithoko's.
  author: 'Thomas Hobbs',
  // Country-level tag, so the pin goes to Bukavu — offset from the tantalum sheet's Kivu
  // markers, since stacked markers hide each other.
  region: [
    {
      name: 'Bukavu',
      country: 'DR Congo',
      coordinates: [28.86, -2.51],
      impact: 'geopolitical',
    },
  ],
  impactList: ['geopolitical'],
  content: {
    sections: [
      { type: 'prose', blocks: [...t.prose[0]] },
      figure('02.jpg', t.captions[1]),
      { type: 'prose', blocks: [...t.prose[1]] },
      figure('03.jpg', t.captions[2]),
      { type: 'prose', blocks: [...t.prose[2]] },
    ],
  },
}
